import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { State } from 'reducers';
import { Credentials } from 'shared/models';
import { getBuildingCredentials, isSavingBuildingCredentials, isBuildingCredentialsDirty } from 'selectors/buildingsSelectors';
import { setCredentialsRequest, newCredentials, changeCredentials, deleteCredentials } from 'actions/buildingActions';
import { urlSlugToBuildingId } from 'ui/shared/urlSlugToBuildingId';
import { onBeforeUnload } from 'ui/shared/onBeforeUnload';
import { CredentialsList } from '../credentialsList/credentialsList';
import { compose } from 'util/compose';
import { Dispatch } from 'redux';

export class BuildingCredentialsPageComponent extends React.Component<any, any> {
    render() {
        const { t, credentials, onClickAdd, onChangeCredentials, onClickDelete, onClickSave, isSaving, isDirty } = this.props;

        const canAdd = credentials.length === 0; // For now, the system only has one type of credentials (thomson-reuters)

        return (
            <div id="building-credentials-page" className="page">
                <button type="button" className="ui basic button" disabled={ !canAdd || isSaving } style={ { marginBottom: '2em' } } onClick={ onClickAdd }>
                    { t('COMMAND.ADD') }
                </button>
                <CredentialsList
                    credentials={ credentials }
                    onChangeCredentials={ onChangeCredentials }
                    onClickDelete={ onClickDelete }
                />
                <button type="button" className="ui basic button" onClick={ onClickSave } disabled={ isSaving || !isDirty }>
                    { t('COMMAND.SAVE') }
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state: State, ownProps: any) => ({
    credentials: getBuildingCredentials(state, ownProps),
    isSaving: isSavingBuildingCredentials(state, ownProps),
    isDirty: isBuildingCredentialsDirty(state, ownProps),
});

const mapDispatchToProps = (dispatch: Dispatch, { buildingId }: any) => ({
    onClickSave: (credentials: Credentials[]) => () => dispatch(setCredentialsRequest({ buildingId, credentials })),
    onClickAdd: () => dispatch(newCredentials(buildingId)),
    onChangeCredentials: (provider: string) => (credentials: Credentials) => dispatch(changeCredentials(buildingId, provider, credentials)),
    onClickDelete: (provider: string) => () => dispatch(deleteCredentials(buildingId, provider)),
});

const mergeProps = (stateProps: any, dispProps: any, ownProps: any) => ({
    ...stateProps,
    ...dispProps,
    ...ownProps,
    onClickSave: dispProps.onClickSave(stateProps.credentials),
});

export const BuildingCredentialsPage = compose(
    withTranslation(),
    urlSlugToBuildingId,
    connect(mapStateToProps, mapDispatchToProps, mergeProps),
    onBeforeUnload,
)(BuildingCredentialsPageComponent);
